import Modal, { ModalProps } from "./components/modal";
import { ContentBoxProps, ContentFormProps, FormCadProps } from "./components/viewCadastro/formCad"
import { PropsViewCad, ViewCad } from "./components/viewCadastro/windowCad";
import { Delete, Save } from "@mui/icons-material";
import { Box } from "@mui/material";
import BackdropWaitingView from "./components/backdropLoading/viewLoadingBackDrop"
import { JSX } from "react";


interface ViewProps<type> {
    formTitle:string
    formSubtitle?:string
    formFieldDescription:string
    loading:boolean
    msg:string
    showAlert:boolean
    status:string
    showDialogExluir:boolean
    contentForm:ContentFormProps[]
    row:type
    buttonNovo:{
        show:boolean,
        onClick:()=>void,
        title:string,
    }
    formValidate:(values:type)=>any
    setShowDialogExluir:(set:boolean)=>any
    handleCloseAlert:()=>any
    handleCloseView:()=>any
    handleExcluir:(row:type)=>any
    handleUpdate:(row:type)=>any
    handleMutator?:([value, field]: any, state: any, { changeValue }: any)=>any
    ContentBox?:(props?: ContentBoxProps<type>) => JSX.Element
}
interface RenderModalProps{
    show:boolean,
    handleClose:()=>any
    width?:"xs"|"sm"|"md"|"lg"|"xl",
    heigth?:'auto'|'100%'
}
export default class View<type>{
    formCad:FormCadProps;
    viewCad:PropsViewCad;
    handleMutator:([value, field]: any, state: any, { changeValue }: any)=>any

    constructor(props: ViewProps<type>){
        //inicializar formCad
        this.handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
            props.handleMutator?
                props.handleMutator([value,field],state,{changeValue})
            :changeValue(state, field, () => value)        
        }

        this.formCad = {
            contentForm:props.contentForm,
            formValidation:props.formValidate,
            handleCancel:()=>{},
            handleOnSubmit:props.handleUpdate,
            handleMutator:this.handleMutator,
            row:props.row,
            buttonActions:[
                {label:"Excluir",icon:<Delete/>, color:"error",variant:"contained",handleOnClick:()=>props.setShowDialogExluir(true),disableType:"personalizado",disabled:(value:any)=>!value._id},
                {label:"Salvar",icon:<Save/>, color:"success",variant:"contained",type:"submit",disableType:"padraoForm"}
            ],  
            ContentBox:props.ContentBox ,
        };

        this.viewCad = {
            title:props.formTitle,
            subtitle:props.formSubtitle,
            row:props.row,
            fieldDescription:props.formFieldDescription,
            loading:props.loading,
            msg:props.msg,
            showAlert:props.showAlert,
            status:props.status,
            handleCloseAlert:props.handleCloseAlert,
            handleCloseForm:props.handleCloseView,
            buttonNovo:{...props.buttonNovo},
            openDialogExcluir:props.showDialogExluir,
            handleExcluir:()=>props.handleExcluir(props.row),
            handleCloseDialogExcluir:()=>props.setShowDialogExluir(false),
            formCad:this.formCad  ,                         
        }
    }
    public render(){
        return (
            <ViewCad {...this.viewCad}/>
        )
    }

    public renderModal(propsModal:RenderModalProps){
        const { handleClose,heigth,show,width } = propsModal
        const Content = () => {
            return (
                <Box sx={{display:"flex",flex:1}}>
                    <BackdropWaitingView showLoading={this.viewCad.loading} msg={this.viewCad.msg} backdropInvisible={false} /> 
                    <ViewCad {...this.viewCad}/>
                </Box>
            )
            
        }
        return(
            <Modal 
                component={<Content  />}
                handleClose={handleClose}
                open={show}
                heigth={heigth?heigth:"100%"}
                width={width?width:"md"}
            />            
        )
    }


   
}